import React, { Fragment } from 'react';
import {useParams} from "react-router-dom";
import ViewReport from './ViewReport';
import { Breadcrumbs } from '../../AbstractElements';

const ViewReportPage = () => {
  var { schedule_id, sequence_id } = useParams();
  
  return (
    <Fragment>
      <Breadcrumbs parent="Schedule" title="Report" />
      <ViewReport ScheduleID={schedule_id} SequenceID = {sequence_id} />
    </Fragment>
  );
};
export default ViewReportPage;